<template>
  <span
    class="icon"
    @click="onClick"
    :class="[
      { spin: spin },
      { disabled: disabled },
      sizeClass,
      { 'color-reset': colorReset },
    ]"
    v-html="getSvg()"
  ></span>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({ name: "icon" })
export default class VIcon extends Vue {
  @Prop({ default: false }) spin?: boolean;
  @Prop({ default: false }) disabled?: boolean;
  @Prop({ default: true }) colorReset?: boolean;

  getIcon() {
    return this.$slots.default && this.$slots.default.length
      ? this.$slots.default[0].text
      : null;
  }

  getSvg() {
    const iconName = this.getIcon();
    if (!iconName) return null;

    try {
      // eslint-disable-next-line @typescript-eslint/no-require-imports
      const module = require(`@/assets/icons/${iconName}.svg?inline`);
      return module.default || module;
    } catch (error) {
      console.error("Error loading icon:", error);
      return null;
    }
  }

  @Prop({ default: "md" })
  size!: "xs" | "sm" | "md" | "lg" | "xl" | "xxl" | "xxxl";

  get sizeClass() {
    return `icon-${this.size}`;
  }

  onClick() {
    if (!this.disabled) {
      this.$emit("click");
    }
  }
}
</script>

<style lang="scss">
.icon {
  color: inherit;
  display: inline-flex;

  &.color-reset {
    > svg {
      path,
      rect {
        fill: currentColor;
        stroke: none;
      }

      line {
        stroke: currentColor;
      }
    }
  }

  > svg {
    font-size: inherit;
    margin: auto;

    display: block;

    * {
      opacity: 1;
    }
  }

  &.spin {
    > svg {
      animation-name: spin;
      animation-duration: 750ms;
      animation-iteration-count: infinite;
      animation-timing-function: linear;
    }
  }
  &.disabled {
    cursor: not-allowed;
    > svg {
      opacity: 0.5;
    }
  }
}

@-ms-keyframes spin {
  from {
    -ms-transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
  }
}
@-moz-keyframes spin {
  from {
    -moz-transform: rotate(0deg);
  }
  to {
    -moz-transform: rotate(360deg);
  }
}
@-webkit-keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
